import type { ISocialLinks } from "../config";

/* import inst from "/assets/images/socials/instagram.svg";
import tg from "/assets/images/socials/telegram.svg";
import x from "/assets/images/socials/twitter.svg";
import youtube from "/assets/images/socials/Youtube.svg";
import facebook from "/assets/images/socials/Facebook.svg"; */

export const socialLinksMock: ISocialLinks = {
  socials: [
    /* { name: "Instagram", href: "#", src: inst },
    { name: "Telegram", href: "#", src: tg },
    { name: "X", href: "#", src: x },
    { name: "YouTube", href: "#", src: youtube },
    { name: "Facebook", href: "#", src: facebook }, */
  ],
};
